import "react-circular-progressbar/dist/styles.css";

import { createFileRoute, Outlet } from "@tanstack/react-router";

import ProfileNavigation from "./-features/components/ProfileNavigation";

export const Route = createFileRoute("/_user-layout/profile/_profile-layout")({
  component: ProfileLayout,
});

function ProfileLayout() {
  return (
    <div className="mt-6 flex w-[93%] mx-auto screen850:w-full screen850:mt-5 flex-col gap-7">
      <ProfileNavigation />
      <Outlet />
    </div>
  );
}
